import { MACKINAC_XRPC_URL } from '@/constants/api'

const GET_TRENDING_TOPICS_NSID = 'app.mackinac.feeds.getTrendingTopics'

export interface TrendingTopic {
    uri: string
    displayName: string
    createdAt: string
}

interface TrendingTopicsResponse {
    topics: TrendingTopic[]
}

/**
 * Fetches trending feed topics from the Mackinac XRPC endpoint.
 * Public endpoint — no auth required.
 * @throws {Error} Network errors or non-OK HTTP responses
 */
export async function fetchTrendingTopics(limit = 5): Promise<TrendingTopic[]> {
    const params = new URLSearchParams()
    params.set('limit', String(limit))
    const url = `${MACKINAC_XRPC_URL}/xrpc/${GET_TRENDING_TOPICS_NSID}?${params.toString()}`

    const response = await fetch(url)

    if (!response.ok) {
        throw new Error(
            `Failed to fetch trending topics: ${response.status} ${response.statusText}`
        )
    }

    const body = (await response.json()) as TrendingTopicsResponse
    if (!Array.isArray(body.topics)) return []
    return body.topics.filter(
        (item): item is TrendingTopic =>
            typeof item === 'object' &&
            item !== null &&
            typeof item.uri === 'string' &&
            typeof item.displayName === 'string' &&
            typeof item.createdAt === 'string'
    )
}
